const contactSupportES = {
	title: "Contacto y Soporte",
	eyebrow: "Soporte",
	tagline: "Personas reales, respuestas reales — normalmente en menos de un día.",
	emailCta: "Escríbenos",
	legal: {
		heading: "¿Buscas nuestras políticas?",
		text: "Los documentos de términos, privacidad y reembolso cubren la mayoría de las dudas de cuenta y facturación.",
	},
	support: {
		title: "¿Necesitas Ayuda?",
		text: "Si tienes preguntas, encuentras un problema o necesitas asistencia con ReservaSinFila, estamos aquí para ayudarte.",
	},
	email: {
		title: "Correo de Soporte",
		text: "Puedes comunicarte con nosotros en cualquier momento al correo:",
	},
	response: {
		title: "Tiempo de Respuesta",
		text: "Respondemos dentro de 24 horas, normalmente mucho más rápido en días laborales.",
	},
};

export default contactSupportES;

